var _style, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyframeArrowsV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 363.13 35.8",
    style: {
      enableBackground: "new 0 0 363.13 35.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EF3E46;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "307.38,0 325.86,17.9 307.38,35.8 344.54,35.8 363.13,17.9 344.65,0 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "279.44,0 297.92,17.9 279.44,35.8 298.02,35.8 316.6,17.9 298.13,0 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "251.49,0 269.98,17.9 251.49,35.8 270.07,35.8 288.66,17.9 270.18,0 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "223.55,0 242.03,17.9 223.55,35.8 242.13,35.8 260.71,17.9 242.24,0 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "195.61,0 214.09,17.9 195.61,35.8 214.19,35.8 232.77,17.9 214.3,0 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "167.66,0 186.14,17.9 167.66,35.8 186.24,35.8 204.83,17.9 186.35,0 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "139.72,0 158.2,17.9 139.72,35.8 158.3,35.8 176.88,17.9 158.41,0 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "111.78,0 130.26,17.9 111.78,35.8 130.36,35.8 148.94,17.9 130.46,0 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "83.83,0 102.31,17.9 83.83,35.8 102.41,35.8 120.99,17.9 102.52,0 "
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "55.89,0 74.37,17.9 55.89,35.8 74.47,35.8 93.05,17.9 74.58,0 "
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "27.94,0 46.42,17.9 27.94,35.8 46.52,35.8 65.11,17.9 46.63,0 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,0 18.48,17.9 0,35.8 18.58,35.8 37.16,17.9 18.69,0 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyframeArrowsV2);
export default __webpack_public_path__ + "static/media/keyframe_arrows_v2.a74f8cc825d1529be01d092d4a569206.svg";
export { ForwardRef as ReactComponent };